import { render, staticRenderFns } from "./teamAccessBlock.vue?vue&type=template&id=0e6620b2&scoped=true&"
import script from "./teamAccessBlock.vue?vue&type=script&lang=js&"
export * from "./teamAccessBlock.vue?vue&type=script&lang=js&"
import style0 from "./teamAccessBlock.vue?vue&type=style&index=0&id=0e6620b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6620b2",
  null
  
)

export default component.exports